import { fn } from "../../../Functions";


export const executeSearch = ( query: string, type: string, limit: number ) => {
    if ( !type ) return;

    fn.goto(`/search?query=${encodeURIComponent(query)}&type=${encodeURIComponent(type)}&limit=${limit}`)
};